import {Controller} from "stimulus"
import $ from 'jquery';
import {createPopper} from '@popperjs/core'


const popperInstance2 = (obj,text) => new Promise((resolve, reject) =>{
        resolve( createPopper(obj, text, {
            placement: "auto",
            strategy: "absolute",
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 8],
                    },
                },
            ],
        }))
    } )
;

function show(obj, instance) {
    obj.setAttribute('data-show', '');
    instance.update();
}

function hide(obj) {
    obj.removeAttribute('data-show');
}

export default class extends Controller {

    tooltip(event){
        let element = document.querySelector('#'+event.currentTarget.dataset.tooltip);

        popperInstance2(event.currentTarget,element)
            .then( result => {
                if(event.type === 'touchstart'){
                    show(element, result);
                }
                if(event.type === 'touchend'){
                    hide(element);
                }
                if(event.type === 'mouseenter'){
                    show(element, result);
                }
                if(event.type === 'mouseleave'){
                    hide(element);
                }

            });

    }

}